export default function copyToClipboard(text) {
    return window.navigator.clipboard.writeText(text);
}
